var render = function render(_c,_vm){return _c('svg',{class:[_vm.data.class, _vm.data.staticClass, 'stella-icon'],style:(_vm.data.staticStyle),attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 6H20M4 12H20M4 18H20","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }